objOrRef